<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="table-responsive" *ngIf="listaReversos">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Código</th>
            <th scope="col">Rut cliente</th>
            <th scope="col">Nombre cliente</th>
            <th scope="col">Pago</th>
            <th scope="col">Monto</th>
            <th scope="col">Fecha</th>
            <th scope="col">Usuario</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let reverso of listaReversos">
            <td>{{reverso.codigo}}</td>

            <td>{{reverso.rutClienteFormato | rut}}</td>

            <td>{{reverso.cliente_proveedor_nombre}}</td>
            <td>{{reverso.pago_codigo}}</td>
            <td>$ {{reverso.monto | numerico}}</td>
            <td>{{reverso.fecha | fecha}}</td>
            <td>{{reverso.nombre_usuario}}</td>
            <td>
              <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                (click)="loadModalReverso(reverso.codigo)" mdbTooltip="Ver" placement="right">
                <mdb-icon fas icon="eye"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"></app-pagination>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow" *ngIf="listaReversos">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="downloadExcel()">
      Excel
    </button>
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn">
      PDF
    </button>
  </div>
</div>

<app-reverso-pagos-modal-add-edit></app-reverso-pagos-modal-add-edit>
